import { render, staticRenderFns } from "./Cozinha.vue?vue&type=template&id=5c170a8b&scoped=true&"
import script from "./Cozinha.vue?vue&type=script&lang=js&"
export * from "./Cozinha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c170a8b",
  null
  
)

export default component.exports